import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";


import CRimg1 from '../../assets/cr1.jpg';
import CRimg2 from '../../assets/cr2.jpg';
import CRimg3 from '../../assets/cr3.jpg';
import CRimg4 from '../../assets/cr4.jpg';
import CRimg5 from '../../assets/cr5.jpg';
import CRimg6 from '../../assets/cr6.jpg';
// import CRimg7 from '../../assets/cr7.jpg';
import CRimg8 from '../../assets/cr8.jpg';
import CRimg9 from '../../assets/cr9.jpg';
import CRimg10 from '../../assets/cr10.jpg';
import CRimg11 from '../../assets/cr11.jpg';
import CRimg12 from '../../assets/cr12.jpg';
import CRimg13 from '../../assets/cr13.jpg';
import CRimg14 from '../../assets/cr14.jpg';
import CRimg15 from '../../assets/cr15.jpg';

// import CRimg16 from '../../assets/CG16.jpg';
// import CRimg17 from '../../assets/CG17.jpg';
// import CRimg18 from '../../assets/CG18.jpg';
//CRimg7, CRimg15, CRimg16 , CRimg17 , CRimg18


const sections = [
  {
   
    images: [CRimg1, CRimg2, CRimg3, CRimg4, CRimg5, CRimg6,  CRimg8 , CRimg9, CRimg10, CRimg11, CRimg12 , CRimg13, CRimg14, CRimg15],
  },
];

const CareerGuidance = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Career Guidance Programme - 2025</h1>
      <p className="intro-third-christmas">Career Guidance Programme 2025, conducted by the Eye Care Institute, aimed to provide students with insights into career opportunities in the field of optometry and eye care</p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};

export default CareerGuidance